import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "../operations/operationModel";
import { PersonInfoModel } from "../../models/person/personInfoModel";

/** Модель ссмены пароля */
export class SbpDefaultModel extends OperationModel {
  public sbpID: string = "";

  public phone: string = "";

  constructor(src: PersonInfoModel) {
    super();
    this.phone = src.Data.MobileTel;
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;

    ord.setProperty("sbpID", this.sbpID, DeclarationPropertiesTypes.String);
    ord.setProperty("phone", this.phone, DeclarationPropertiesTypes.String);
    ord.setProperty("delete", 'false', DeclarationPropertiesTypes.Boolean);

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    if (args) {
      this.sbpID = args[0].values[0] || "";
      this.phone = args[0].values[1] || "";
    }
    console.log("No implemetation");
  }
}
